'use client';

import { useState } from 'react';

import { CloseIcon, InlineButton, Modal, Reveal } from '@web/ui';

import { TermsContent } from './TermsContent';

type TermsAndConditionsProps = {
  mode?: 'inline' | 'modal';
  markdownContent?: string;
};

export function TermsAndConditions({
  mode = 'inline',
  markdownContent = '',
}: TermsAndConditionsProps) {
  const [open, setOpen] = useState(false);

  if (mode === 'inline') {
    return <TermsContent markdownContent={markdownContent} />;
  }

  return (
    <Reveal direction="right">
      <InlineButton onClick={() => setOpen(true)}>
        Terms & Conditions
      </InlineButton>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        width="min(900px, 94vw)"
      >
        <div
          style={{
            maxHeight: '90svh',
            overflowY: 'auto',
            position: 'relative',
          }}
        >
          <button
            type="button"
            aria-label="Close terms and conditions"
            onClick={() => setOpen(false)}
            style={{
              alignItems: 'center',
              background: 'transparent',
              border: 'none',
              color: 'inherit',
              cursor: 'pointer',
              display: 'inline-flex',
              height: '2rem',
              justifyContent: 'center',
              padding: 0,
              position: 'absolute',
              right: '1rem',
              top: '1rem',
              width: '2rem',
              zIndex: 1,
            }}
          >
            <CloseIcon size={16} />
          </button>
          <TermsContent markdownContent={markdownContent} />
        </div>
      </Modal>
    </Reveal>
  );
}
